import React, { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";
import ErrorBanner from "../components/ui/ErrorBanner";
import SkeletonList from "../components/ui/SkeletonList";

import { IoMdArrowBack } from "react-icons/io";
import { IoClose } from "react-icons/io5";
import { RiInformation2Fill } from "react-icons/ri";

import { useNavigate } from "react-router-dom";
import { useLoading } from "../context/LoadingContext";
import { fetchRebateList } from "../utils/api";
import FloatingMenu from "../components/FloatingMenu";

const Rebate = () => {
    const { t } = useTranslation();
    const { setLoading } = useLoading();
    const navigate = useNavigate();

    const [errorMessage, setErrorMessage] = useState("");

    const [rebateLoading, setRebateLoading] = useState(true);
    const [rebateList, setRebateList] = useState([]);

    useEffect(() => {
        const loadData = async () => {
            setLoading(true);
            setRebateLoading(true);
            setErrorMessage("");

            try {
                const response = await fetchRebateList();
                if (response.success && Array.isArray(response.data) && response.data.length > 0) {
                    setRebateList(response.data);
                } else {
                    setRebateList([]);
                }
            } catch (error) {
                setErrorMessage(t("pleaseTryLater"));
            } finally {
                setLoading(false);
                setRebateLoading(false);
            }
        };

        loadData();
    }, [setLoading, t]);

    useEffect(() => {
        if (errorMessage) {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, [errorMessage]);

    return (
        <section className="page-shell">
            <div className="page-header">
                <div
                    className="cursor-pointer bg-secondary container-back-button text-color-blue rounded-full"
                    onClick={() => navigate("/")}
                >
                    <IoMdArrowBack className="size-sm" />
                    <span className="text-sm">
                        {t("backToLobby")}
                    </span>
                </div>
                <button className="cursor-pointer" onClick={() => navigate("/")}>
                    <IoClose className="size-lg text-color-blue" />
                </button>
            </div>

            <ErrorBanner message={errorMessage} />

            <div className="p-4">
                <p className="page-title-centered">
                    {t("rebate")}
                </p>
                <div className="mb-6">
                    <div className="info-banner">
                        <RiInformation2Fill className="size-lg text-border-yellow" />
                        <div className="flex flex-col flex-grow">
                            <span className="text-xs text-white">
                                {t("DailyRebate")}.
                            </span>
                        </div>
                    </div>
                </div>

                {rebateLoading ? (
                    <SkeletonList
                        rows={rebateList.length || 1}
                        className="rounded-lg"
                    />
                ) : (
                    <div className="list-card">
                        {rebateList.length > 0 ? (
                            rebateList.map((rebate, index) => (
                                <div
                                    key={rebate?.id ?? rebate?.product_name ?? index}
                                    className="rate-row"
                                >
                                    <span className="text-sm flex-between">
                                        {rebate.product_name}
                                    </span>
                                    <span className="text-sm text-color-blue">
                                        {Number(rebate.rate).toFixed(2)} %
                                    </span>
                                </div>
                            ))
                        ) : (
                            <div className="empty-state">
                                {t("noRebatesFound")}
                            </div>
                        )}
                    </div>
                )}
            </div>

            <FloatingMenu />
        </section>
    );
};

export default Rebate;